<template>
  <div
    class="hidden text-black/50 md:flex md:w-full md:items-center md:gap-x-4"
  >
    <UILink
      to="/trackers"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Trackers
    </UILink>
    <UILink
      to="/geofences"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Geofences
    </UILink>
    <UILink
      v-if="$can('use', 'Insights')"
      to="/insights"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Insights
    </UILink>
    <UILink
      v-if="$can('view', 'Dashboard')"
      to="/dashboards"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Dashboards
    </UILink>
    <UILink
      v-if="canTrackShipments && $can('view', 'Shipments')"
      to="/shipments"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Shipments
    </UILink>
    <UILink
      v-if="$can('view', 'ContainerTypes')"
      to="/find-containers"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Containers
    </UILink>
    <UILink
      to="/alerts"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Alerts
    </UILink>
    <UILink
      to="/reports"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Reports
    </UILink>
    <UILink
      v-if="hasRulesEngine && $can('manage', 'Rules')"
      to="/rules"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Rules
    </UILink>
    <UILink
      v-if="$can('manage', 'MapOverlay')"
      to="/overlays"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Overlays
    </UILink>
    <UILink
      to="/settings"
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6"
    >
      Settings
    </UILink>
    <NavIntercomLauncher
      class="text-lgmx_15 pb-px pt-[2px] font-medium leading-6 md:hidden lg:block"
    />
    <div class="ml-auto flex items-center">
      <NavAccountDropdown />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavAccountDropdown from '@/components/_common/nav/NavAccountDropdown.vue';
import NavIntercomLauncher from '@/components/_common/nav/NavIntercomLauncher.vue';
import { UserRole } from '@gpx-spa/constants';

export default {
  components: {
    NavAccountDropdown,
    NavIntercomLauncher,
  },
  computed: {
    ...mapGetters({
      account: 'auth/account',
      user: 'auth/user',
      role: 'auth/role',
    }),
    canTrackShipments() {
      return this.account?.can_track_shipments;
    },
    hasRulesEngine() {
      return this.account?.has_rules_engine;
    },
  },
};
</script>
